import { createForm } from '../../../factories'

export default createForm(['name', 'file', 'thumbnail'])



// WEBPACK FOOTER //
// ./src/store/modules/media/forms/store.js